import { useCallback, useRef, useState } from 'react';
import { sidebarIcons } from 'src/layouts/SidebarV2/icons';
import { IconAction } from 'src/layouts/SidebarV2/primitives';

import { HistoryFlyout } from './HistoryFlyout';

export interface CollapsedHistoryProps {
  onExpand: () => void;
}

// Grace period bridging the cursor path from the icon to the top-anchored panel.
const CLOSE_DELAY_MS = 180;

const CollapsedHistory = ({ onExpand }: CollapsedHistoryProps) => {
  const [open, setOpen] = useState(false);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelClose = useCallback(() => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  }, []);

  const openNow = useCallback(() => {
    cancelClose();
    setOpen(true);
  }, [cancelClose]);

  const closeSoon = useCallback(() => {
    cancelClose();
    closeTimer.current = setTimeout(() => setOpen(false), CLOSE_DELAY_MS);
  }, [cancelClose]);

  return (
    <div className="tw:relative tw:flex tw:justify-center">
      <span onMouseEnter={openNow} onMouseLeave={closeSoon}>
        <IconAction
          icon={sidebarIcons.history}
          label="Chat History"
          iconSize={20}
          colorClass="tw:text-icon-primary"
          className="tw:w-2-5xl tw:rounded-full tw:h-2-5xl tw:p-s tw:hover:bg-secondary-hover tw:hover:text-text-primary"
          onClick={onExpand}
        />
      </span>
      {open ? (
        // Flush to the collapsed rail's right edge (60px = DrawerV2 COLLAPSED_WIDTH).
        <div
          className="tw:fixed tw:left-[60px] tw:top-0 tw:z-1300 tw:h-screen"
          onMouseEnter={openNow}
          onMouseLeave={closeSoon}
        >
          <div className="tw:h-full tw:rounded-r tw:shadow-e2">
            <HistoryFlyout />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export { CollapsedHistory };
